import React from "react";
import Box from "@mui/material/Box";

const TopSongGlobal = () => {

    return (
        <Box sx={{display: 'flex'}}>
            <p>Top song global Page</p>
        </Box>
    );
}

export default TopSongGlobal;
